import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { CheckCircle } from 'react-feather'
import AnimatedBackground from '../common/AnimatedBackground'
import './ThankYou.css'

export default function ThankYou() {
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1)
    }, 1000)

    const redirect = setTimeout(() => {
      navigate('/')
    }, 5000)

    return () => {
      clearInterval(timer)
      clearTimeout(redirect)
    }
  }, [navigate])

  return (
    <section className="thank-you-section">
      <AnimatedBackground  />
      <div className="thank-you-container">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", duration: 0.8 }}
          className="thank-you-icon"
        >
          <CheckCircle size={64} />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="thank-you-content"
        >
          <h1>Thank You!</h1>
          <p>Your feedback has been successfully submitted.</p>
          <div className="redirect-message">
            Redirecting to homepage in {countdown} seconds...
          </div>
        </motion.div>
      </div>
    </section>
  )
}

